import queryString from "query-string";

type Response = {
  isValid: boolean;
  name: string;
  address: {
    zip: string;
    houseNumber: string;
    houseNumberAddition: string;
    street: string;
    city: string;
  };
};

export async function fetchCocDetails(
  endpoint: string,
  cocNumber: string
): Promise<Response> {
  const url = queryString.stringifyUrl({
    url: endpoint,
    query: { cocNumber },
  });

  return fetch(url, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      if (response.status >= 200 && response.status < 300) {
        return response.json();
      }
    })
    .catch((err) => err);
}
